document.addEventListener("DOMContentLoaded", function () {
  // Muestra u oculta el campo de mensaje segun el checkbox de ese grabado.
  document.addEventListener("change", function (event) {
    const checkbox$ = event.target.closest(".grabado-laser-option__checkbox");
    if (!checkbox$) return;

    const option$ = checkbox$.closest(".grabado-laser-option");
    const messageWrapper$ = option$?.querySelector(".grabado-laser-option__message");
    const messageInput$ = option$?.querySelector(".grabado-laser-option__message-input");
    if (!messageWrapper$) return;

    messageWrapper$.hidden = !checkbox$.checked;
    if (!checkbox$.checked && messageInput$) messageInput$.value = "";
  });

  // Al agregar al carrito, agrega primero TODOS los grabados tildados y despues
  // reenvia el form original. Un producto puede ofrecer mas de uno a la vez
  // (por ejemplo un combo con mate + matera + termo).
  document.addEventListener(
    "click",
    async function (event) {
      const button$ = event.target.closest('button[type="submit"]');
      if (!button$) return;

      const form$ = button$.closest('form[data-type="add-to-cart-form"]');
      if (!form$) return;

      const productFormComponent$ = form$.closest("product-form-component");
      if (!productFormComponent$) return;
      if (productFormComponent$.dataset.addingGrabado === "true") return;

      const selected$ = Array.from(
        productFormComponent$.querySelectorAll(".grabado-laser-option")
      ).filter(function (option$) {
        return option$.querySelector(".grabado-laser-option__checkbox")?.checked;
      });
      if (selected$.length === 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const items = selected$.map(function (option$) {
        const checkbox$ = option$.querySelector(".grabado-laser-option__checkbox");
        const messageInput$ = option$.querySelector(".grabado-laser-option__message-input");
        const messageText = messageInput$?.value.trim() ?? "";
        const messageLabel = option$.dataset.messageLabel;

        const properties = { "Grabado para": checkbox$.dataset.productTitle };
        if (messageText && messageLabel) properties[messageLabel] = messageText;

        return { id: parseInt(checkbox$.dataset.variantId, 10), quantity: 1, properties };
      });

      // Se destildan antes del fetch para que un segundo click no duplique.
      selected$.forEach(function (option$) {
        option$.querySelector(".grabado-laser-option__checkbox").checked = false;
        const messageWrapper$ = option$.querySelector(".grabado-laser-option__message");
        if (messageWrapper$) messageWrapper$.hidden = true;
      });
      productFormComponent$.dataset.addingGrabado = "true";

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items }),
        });
        if (!response.ok) throw new Error("Failed to add grabado laser");

        productFormComponent$.dataset.addingGrabado = "false";
        selected$.forEach(function (option$) {
          const messageInput$ = option$.querySelector(".grabado-laser-option__message-input");
          if (messageInput$) messageInput$.value = "";
        });
        form$.requestSubmit();
      } catch (error) {
        console.error("Error adding grabado laser:", error);
        // Se restaura lo tildado para que el cliente pueda reintentar.
        selected$.forEach(function (option$) {
          option$.querySelector(".grabado-laser-option__checkbox").checked = true;
          const messageWrapper$ = option$.querySelector(".grabado-laser-option__message");
          if (messageWrapper$) messageWrapper$.hidden = false;
        });
        productFormComponent$.dataset.addingGrabado = "false";
      }
    },
    true
  );
});
